$(function(){
	$('[id^=set_lang_]').on('click', function(){
		var langPath = this.hreflang // ['/', '/en/', '/ch/', '/ko/']
		var lang = langPath.replace(/\//g, '') || 'ja' // ['ja', 'en', 'ch', 'ko']
		var setUrl = $('[data-' + lang + '-url]').data(lang + '-url')
		var href = ''

		try {
			// URL設定がある場合
			if (setUrl !== undefined) {
				// 設定はあるのに空値の場合
				if (! setUrl) {
					// この言語のページは存在しないので例外で処理する
					throw('Set url is not found.')
				}
				href = setUrl
			}
			else {
				//言語表示期間の期限設定(1日)
				const limit = new Date().getTime() + (60 * 60 * 24 * 1000);
				localStorage.setItem("languageLimit", limit);

				var path = langPath + location.pathname.replace(/^\/(en|ch|zh|ko)\//, '')
				href = path.replace('\/\/', '/') + location.search
			}
		} catch (e) {
			// 設定があるのに空値だった場合、行き先がないのでその言語のトップへ飛ばす
			href = langPath
		}

		window.location.href = href

	})
})
